/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import {DotAlertBanner} from '@digital-ai/dot-components';

export const StyledAlertBanner = styled(DotAlertBanner)`
    margin-left: auto;
    margin-right: auto;
    margin-top: 1rem;
`;
